import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import LogoutContent from "../../components/Authentication/LogoutContent";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Remove login cookies when logging out
    localStorage.removeItem('neuro_patientportal_auth_token')
    Cookies.remove("user");

    // ✅ Optional delay to show the logout screen briefly (1.2 seconds)
    const timer = setTimeout(() => {
      navigate("/authentication/sign-in/", { replace: true });
    }, 1200);

    // cleanup on unmount
    return () => clearTimeout(timer);
  }, [navigate]);

  return <LogoutContent />;
};

export default Logout;